import React, { Children, cloneElement } from 'react';
import PropTypes from 'prop-types';
import { get, isArray } from 'lodash';
import Field from '../Field';
import styles from './styles.module.scss';

export default class CheckBoxGroupField extends React.Component {
  static propTypes = {
    type: PropTypes.oneOf(['check', 'button']),
    inline: PropTypes.bool,
    valueField: PropTypes.object,
    disabled: PropTypes.bool,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element])
      .isRequired,
  };

  static defaultProps = {
    type: 'check',
    disabled: false,
    inline: true,
    valueField: undefined,
  };

  handleChange = event => {
    const { valueField } = this.props;
    const { onChange, value: groupValue } = valueField;
    const checked = get(event, 'target.checked');
    const value = get(event, 'target.value');

    const nextValue = isArray(groupValue) ? [...groupValue] : [];

    if (checked && !nextValue.includes(value)) {
      nextValue.push(value);
    } else {
      const index = nextValue.indexOf(value);

      if (index !== -1) {
        nextValue.splice(index, 1);
      }
    }

    onChange(nextValue);
  };

  cloneInput(input) {
    const { type, valueField, disabled } = this.props;
    const { value: groupValue } = valueField;

    const value = get(input, 'props.value');
    const checked = isArray(groupValue) && groupValue.includes(value);

    return cloneElement(input, {
      onChange: this.handleChange,
      disabled: get(input, 'props.disabled', disabled),
      checked,
      type,
    });
  }

  render() {
    const { inline, children } = this.props;

    return (
      <Field {...this.props} className={styles['group']}>
        {Children.map(children, child =>
          inline ? this.cloneInput(child) : <div>{this.cloneInput(child)}</div>
        )}
      </Field>
    );
  }
}
